let redirectSignIn = process.env.REACT_APP_REDIRECT_URI;
let redirectSignOut = process.env.REACT_APP_LOGOUT_REDIRECT_URI;
const redirectToOrigin = process.env.REACT_APP_REDIRECT_TO_ORIGIN == 'true';

const replaceOrigin = (url) => {
  const newUrl = new URL(url);
  if (typeof(window) !== 'undefined') {
    newUrl.host = window.location.host
  }
  return newUrl.href;
}

if (redirectToOrigin) {
  redirectSignIn = replaceOrigin(redirectSignIn);
  redirectSignOut = replaceOrigin(redirectSignOut);
}

module.exports = {
  domain: process.env.REACT_APP_DOMAIN,
  scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  redirectSignIn: redirectSignIn,
  redirectSignOut: redirectSignOut,
  responseType: "code"
}